import { render } from "./newCompany.vue?vue&type=template&id=607d86d0"
import script from "./newCompany.vue?vue&type=script&lang=js"
export * from "./newCompany.vue?vue&type=script&lang=js"

import "./newCompany.vue?vue&type=style&index=0&id=607d86d0&lang=css"

import exportComponent from "C:\\Projects\\wld\\wlt-admin-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__